<template>
  <div class="cell-field">
    <cell :cellName="label">
      <input :type="type"
        :placeholder="placeholder"
        @input="handleInput"
        :value="currentValue"
        @change="$emit('change', currentValue)"
        slot="value"
        :disabled="disabled"
        >
    </cell>
  </div>
</template>

<script>
import Cell from './Cell.vue';

export default {
  components: {
    Cell,
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  props: {
    label: String,
    type: {
      type: String,
      default: 'text',
    },
    placeholder: String,
    value: {},
    disabled: Boolean,
  },
  methods: {
    handleInput(e) {
      this.currentValue = e.target.value;
    },
  },
  watch: {
    currentValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.currentValue = val;
    },
  },
};
</script>

<style>

</style>
